$('.dropdown').mouseenter(function () {
  $(this).find('.wrap').addClass('is-dropdown');

});
$('.dropdown').mouseleave(function () {
  $(this).find('.wrap').removeClass('is-dropdown');

});



// .entry-btns a をクリックしたら .entry-menu がフェードイン
$(".entry-btns a").on("click", function (event) {
  event.preventDefault();
  $(".entry-menu").fadeIn(200);
});

$(".sp-entry-btn").on("click", function (event) {
  event.preventDefault();
  $(".entry-menu").fadeIn(200);
});

// .close-btn をクリックしたら .entry-menu がフェードアウト
$(".close-btn").on("click", function () {
  $(".entry-menu").fadeOut(200);
});

